import React from "react";
import { Lock } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Élément masqué réutilisable.
 * - mode "blur": floute complètement la valeur + cadenas.
 * - mode "partial": masque partiellement un chiffre (ex "8█ %").
 */
export const MaskedValue = ({
    value = "",
    label,
    mode = "blur", // "blur" | "partial"
    revealCount = 1, // nb de caractères visibles en mode partial
    className,
    dataTestId = "masked-value",
}) => {
    const renderPartial = () => {
        const str = String(value);
        const visible = str.slice(0, revealCount);
        const hidden = str.slice(revealCount).replace(/[^\s%]/g, "█");
        return (
            <span className="font-display font-black text-3xl text-white tracking-tight">
                {visible}
                <span className="text-revtext-secondary">{hidden}</span>
            </span>
        );
    };

    return (
        <div
            data-testid={dataTestId}
            className={cn(
                "relative overflow-hidden rounded-xl bg-ink-900 border border-ink-700 p-4 flex items-center justify-between gap-3",
                className,
            )}
        >
            <div className="flex flex-col">
                {label ? (
                    <span className="text-sm text-revtext-secondary">{label}</span>
                ) : null}
                {mode === "partial" ? (
                    renderPartial()
                ) : (
                    <span
                        className="font-display font-black text-3xl text-white tracking-tight blur-[7px] select-none"
                        aria-hidden
                    >
                        {value || "88 %"}
                    </span>
                )}
            </div>
            <span className="shrink-0 w-10 h-10 rounded-full bg-ink-800 border border-ink-700 flex items-center justify-center">
                <Lock size={18} className="text-revtext-secondary" />
            </span>
        </div>
    );
};
